import { Injectable } from '@angular/core';
import { ProcessDesignerUIState } from './process-designer.uistate';
import { ElementPropertyConfig, PropertyEntity } from '@farris/ide-property-panel';
import { CallActivitySubProcessComponent, CallActivitySubProcessConverter } from '../views/call-activity-sub-process/call-activity-sub-process.component';
import { BackwardRuleComponent, BackwardRuleConverter } from '../views/backward-rule/backward-rule.component';
import { VariableSettingComponent, VariableSettingConverter } from '../views/variable-setting/variable-setting.component';
import { CallActivitySubProcess2Component, CallActivitySubProcess2Converter } from '../views/call-activity-sub-process2/call-activity-sub-process2.component';
import { CallActivitySubProcessPropertyKeys } from '../designer/wf-cell/property-keys/CallActivitySubProcessPropertyKeys';
import { WfLocalePipe } from '../i18n/pipe/wf-process-editor-locale.pipe';
import { MultiInstanceLoopCharacteristicsComponent, MultiInstanceLoopCharacteristicsConverter } from '../views/multi-instance-loop-characteristics/multi-instance-loop-characteristics.component';

@Injectable()

export class SubProcessViewModel {
    constructor(
        private uiState: ProcessDesignerUIState,
        private localPipe: WfLocalePipe
        ) {
    }
    setProperty(obj: any) {
        this.uiState.propertyData = obj.propertyData;
        this.uiState.propertyConfig = this.setConfig(obj.propertyConfig);
    }

    private setConfig(obj: any[]): ElementPropertyConfig[] {
        const propertyConfig: ElementPropertyConfig[] = [];
        if (obj) {
            obj.forEach((element: ElementPropertyConfig) => {
                this.setEntity(element.properties);
                propertyConfig.push(element);
            });
        }
        return propertyConfig;
    }
    private setEntity(obj: PropertyEntity[]) {
        if (obj && obj.length > 0) {
            obj.forEach((item: PropertyEntity) => {
                switch (item.propertyID) {
                    case CallActivitySubProcessPropertyKeys.callActivitySubProcess: // 参与者
                        // item.editor = CallActivitySubProcessComponent;
                        // item.converter = new CallActivitySubProcessConverter();
                        item.editor = CallActivitySubProcess2Component;
                        item.converter = new CallActivitySubProcess2Converter(this.localPipe);
                        item.editorParams = {
                            bizTypeId: this.uiState.flowFormInfo.flowForm.businessObjectId,
                        };
                        break;
                    case CallActivitySubProcessPropertyKeys.BackWardRule:
                        item.editor = BackwardRuleComponent;
                        item.converter = new BackwardRuleConverter(this.localPipe);
                        item.editorParams = {
                            nodeType: 'CallActivitySubProcess'
                        };
                        break;
                    case CallActivitySubProcessPropertyKeys.MultiInstanceLoopCharacteristics:
                            item.editor = MultiInstanceLoopCharacteristicsComponent;
                            item.converter = new MultiInstanceLoopCharacteristicsConverter(this.localPipe);
                            item.editorParams = {
                                location: 'CallActivitySubProcess'
                            };
                            break;
                    case CallActivitySubProcessPropertyKeys.variableSettings: // 变量设置
                        item.editor = VariableSettingComponent;
                        item.converter = new VariableSettingConverter(this.localPipe);
                        break;
                    default:
                        break;
                }
            });
        }
    }
}
